import y from "../../../../public/projects/tvs/projects/y.jpg";
import s from "../../../../public/projects/tvs/logo/tvs.png";
import evergreen from "../../../../public/projects/tvs/projects/ev.jpg"

// emeraldcascadia
import overviewImageemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/overview/1.webp";
import bannerDesktopImageemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/banner/1.webp";
import bannerdeveloperemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/banner/3.webp";
import bannerMobileImageemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/banner/2.webp";
import Locationemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/location/1.webp";
import Hightlightsemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/highlights/1.webp";
import floorplan1emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/floorplan/1.webp";
import floorplan2emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/floorplan/2.webp";
import floorplan3emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/floorplan/3.webp";
import floorplan4emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/floorplan/4.webp";
import floorplan5emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/floorplan/5.webp";
import locationiconemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/overview/l.png";
import caliconemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/overview/c.png";
import newlaunchiconemeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/overview/n.png";
import gallery1emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/gallery/1.webp";
import gallery2emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/gallery/2.webp";
import gallery3emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/gallery/3.webp";
import gallery4emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/gallery/4.webp";
import gallery5emeraldcascadia from "../../../../public/projects/tvs/emeraldcascadia/gallery/5.webp";


// isleoftrees
import overviewImageisleoftrees from "../../../../public/projects/tvs/isleoftrees/overview/1.webp";
import bannerDesktopImageisleoftrees from "../../../../public/projects/tvs/isleoftrees/banner/1.webp";
import bannerdeveloperisleoftrees from "../../../../public/projects/tvs/isleoftrees/banner/3.webp";
import bannerMobileImageisleoftrees from "../../../../public/projects/tvs/isleoftrees/banner/2.webp";
import Locationisleoftrees from "../../../../public/projects/tvs/isleoftrees/location/1.webp";
import Hightlightsisleoftrees from "../../../../public/projects/tvs/isleoftrees/highlights/1.webp";
import floorplan1isleoftrees from "../../../../public/projects/tvs/isleoftrees/floorplan/1.webp";
import floorplan2isleoftrees from "../../../../public/projects/tvs/isleoftrees/floorplan/2.webp";
import floorplan3isleoftrees from "../../../../public/projects/tvs/isleoftrees/floorplan/3.webp";
import floorplan4isleoftrees from "../../../../public/projects/tvs/isleoftrees/floorplan/4.webp";
import floorplan5isleoftrees from "../../../../public/projects/tvs/isleoftrees/floorplan/5.webp";
import locationiconisleoftrees from "../../../../public/projects/tvs/isleoftrees/overview/l.png";
import caliconisleoftrees from "../../../../public/projects/tvs/isleoftrees/overview/c.png";
import newlaunchiconisleoftrees from "../../../../public/projects/tvs/isleoftrees/overview/n.png";
import gallery1isleoftrees from "../../../../public/projects/tvs/isleoftrees/gallery/1.webp";
import gallery2isleoftrees from "../../../../public/projects/tvs/isleoftrees/gallery/2.webp";
import gallery3isleoftrees from "../../../../public/projects/tvs/isleoftrees/gallery/3.webp";
import gallery4isleoftrees from "../../../../public/projects/tvs/isleoftrees/gallery/4.webp";
import gallery5isleoftrees from "../../../../public/projects/tvs/isleoftrees/gallery/5.webp";

export const developertvs = {

  properties: [
    {
      name: "TVS Emerald Cascadia",
      image: bannerdeveloperemeraldcascadia,
      price: " 6.49 Crore Onwards",
      state: "Bangalore",
      developer: "TVS",
      projectlocation: "Central Bangalore",
      location: "Sudhama Nagar, Mission Road, Bangalore",
      bed: "3 & 4 BHK",
      size: "1473 - 2318 sq.ft.",
      url: `/tvs-emerald-cascadia`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "TVS Emerald Cascadia", 
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "TVS Isle of Trees",
      image: bannerdeveloperisleoftrees,
      price: "1.83 Crore Onwards",
      state: "Bangalore",
      developer: "TVS",
      projectlocation: "Central Bangalore",
      location: "Rachenahalli, Hebbal, Bangalore",
      bed: "3 & 4 BHK",
      size: "1500 - 2375 sq.ft.",
      url: `/tvs-isle-of-trees`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "TVS Isle of Trees", 
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};


export const Headers = {
  logo: s,
  data: {
    experience: "2013",
  },
  about: `TVS Emerald, the real estate arm of the TVS Group, was established in 2013 with a vision to create landmark properties characterized by excellent design, superior quality, and customer-centric values. Built on the legacy of trust and reliability of the TVS Group which was founded in 1911, TVS Emerald brings decades of business excellence to the real estate sector.

The company focuses on developing residential properties that reflect their commitment to innovation, sustainability, and timely delivery. With a customer-first approach, TVS Emerald has successfully established itself as a premium developer in South India, particularly in Bangalore and Chennai, delivering spaces that enhance the quality of life for residents while creating lasting value.`,
};


export const projectstvs = {

  emeraldcascadia: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageemeraldcascadia,
      bannerMobileImage: bannerMobileImageemeraldcascadia,
      textOverlay: "",
      data: {
        title: "TVS Emerald Cascadia",
        subtitle: "Sudhama Nagar, Mission Road, Bangalore",
        starting_price: "₹ 6.49 Crore Onwards",
        payment_plan: "CLP",
        rerano: "P52100052683",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Discover Luxury Living at TVS Emerald Cascadia",
      description: [
        "TVS Emerald Cascadia in Sudhama Nagar, Mission Road, Bangalore, stands as an ultra-luxury residential destination for discerning homebuyers seeking a blend of nature-inspired living and urban sophistication. This exclusive development spans 1.1 acres and features a single iconic tower with just 63 premium residences, offering 3, 4, and even 5 BHK apartments and penthouses. Each home is meticulously designed with spacious layouts, large balconies, and high-end interiors, ensuring a lavish lifestyle in the heart of Central Bangalore.",
        "Strategically located on Mission Road in the Central Business District, TVS Emerald Cascadia boasts unmatched connectivity to Bangalore's major business hubs, educational institutions, healthcare centers, and entertainment zones. Landmarks such as Lalbagh Botanical Gardens, Cubbon Park, UB City, and Vidhan Soudha are just minutes away, making it an ideal address for professionals and families who value both convenience and tranquility.",
      ],
      keywordLinks: {
        "Experion": "/developers/experion",
      },
      image: overviewImageemeraldcascadia,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconemeraldcascadia,
          title: "₹ 6.49 Crore Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconemeraldcascadia,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconemeraldcascadia,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    
    floor_plan: [
      {
        type: "3 BHK",
        area: "1473 sq. ft.",
        price: "₹ 6.49 Crore Onwards",
        image: floorplan1emeraldcascadia,
      },
      {
        type: "4 BHK",
        area: "1817 sq. ft.",
        price: "₹ 8.01 Crore Onwards",
        image: floorplan2emeraldcascadia,
      }, 
      {
        type: "4 BHK Premium",
        area: "2318 sq. ft.",
        price: "₹ 10.21 Crore Onwards",
        image: floorplan3emeraldcascadia,
      },

    ],
    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1473 sq. ft.",
          price: "₹ 6.49 Crore Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1817 sq. ft.",
          price: "₹ 8.01 Crore Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK Premium",
          area: "2318 sq. ft.",
          price: "₹ 10.21 Crore Onwards",
          eoiAmount: "On Request",
        },

      ],
     

    },
     highlights: {
      images: Hightlightsemeraldcascadia,
      tagline: "Highlights",
      features: [
        "Development spans across 1.15 acres",
        "Single tower with 22 stories",
        "Only 63 premium residences",
        "IGBC Platinum pre-certified",
        "Over 25 world-class amenities",
      ],
    },

    location: {
      image: Locationemeraldcascadia, 
      data: [
        {
          airport: {
            distance_time: "36.3 km",
            name: "Kempegowda International Airport"
          },
          school: {
            distance_time: "1.7 Km",
            name: "Cambridge High School"
          },
          railwayormetro: {
            distance_time: "5.6 Km",
            name: "NH 48"
          },
          hospital: {
            distance_time: "1 Km",
            name: "P D Hinduja Sindhi Hospital"
          },
          mall: {
            distance_time: "1 Km",
            name: "St Joseph's University"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1emeraldcascadia },
        { image: gallery2emeraldcascadia },
        { image: gallery3emeraldcascadia },
        { image: gallery4emeraldcascadia },
        { image: gallery5emeraldcascadia },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in TVS Emerald Cascadia, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is TVS Emerald Cascadia located?",
        answer: `TVS Emerald Cascadia is strategically located in Sudhama Nagar, Mission Road, in the Central Business District of Bangalore.`,
      },
      {
        question: "What are the available configurations of the residences?",
        answer: `The project offers a 3 BHK Apartments in the size of 1473 sq.ft. and 4 BHK Apartments in size range of 1817 - 2318 sq.ft.`,
      },
      {
        question: "What is the starting price for these residences?",
        answer: `The 3 BHK apartments start at ₹ 6.49 Crore Onwards, while 4 BHK apartments range from ₹ 8.01 to ₹ 10.21 Crore Onwards.`,
      },
      {
        question: "What amenities are offered at TVS Emerald Cascadia?",
        answer: `The project boasts over 25 world-class amenities, including a temperature-controlled infinity pool, rooftop gardens with panoramic city views, a fully equipped gym, mini theatre, spa, children's play area, and exclusive concierge services.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, TVS Emerald Cascadia is RERA registered, ensuring transparency, legal compliance, and protection of homebuyers' interests.`,
      },
      {
        question: "What makes TVS Emerald Cascadia a standout choice for homebuyers?",
        answer: `Its prime location in Central Bangalore, developer credibility, exclusive design with only 63 units, and comprehensive amenities make it an ideal choice for discerning homebuyers.`,
      },
      {
        question: "What is the status of the project?",
        answer: `The project is currently in the New Launch phase.`,
      },
      {
        question: "How is the connectivity to major parts of Bangalore?",
        answer: `The location offers excellent connectivity to Bangalore's major business hubs, educational institutions, healthcare centers, and entertainment zones. Landmarks such as Lalbagh Botanical Gardens, Cubbon Park, UB City, and Vidhan Soudha are just minutes away.`,
      },
      {
        question: "Are there good educational institutions nearby?",
        answer: `Yes, Cambridge High School is just 1.7 km away, and St Joseph's University is approximately 1 km from the project.`,
      },
      {
        question: "What healthcare facilities are in the vicinity?",
        answer: `P D Hinduja Sindhi Hospital is located just 1 km from the project, ensuring residents have access to quality healthcare services.`,
      },
    ],

    similar:{
      properties: [
     
        {
          name: "TVS Emerald Cascadia - CBD",
          image: y,
          price: "₹ 6.49 Crore Onwards",
          developer:"TVS",
          state:"Bangalore",
          location: "Sudhama Nagar, Mission Road, Bangalore",
          projectlocation:"Central Bangalore",
          bed: "3 & 4 BHK",
          size: "1473 - 2318 sq.ft.",
          url: `/tvs-emerald-cascadia-mission-road-bangalore`,
          form:{
            source_id:11,
            api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id:130,
            builder_id:`103`,
            project_id:`477`,
            subject: "TVS Emerald Cascadia", 
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry - TVS Emerald Cascadia", 
       to_email: "leads@gurugram-property.com",
     },
  },

  
  isleoftrees: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageisleoftrees,
      bannerMobileImage: bannerMobileImageisleoftrees,
      textOverlay: "",
      data: {
        title: "TVS Isle of Trees",
        subtitle: "Rachenahalli, Hebbal, Bangalore",
        starting_price: "₹ 1.83 Crore Onwards",
        payment_plan: "CLP",
        rerano: "PRM/KA/RERA/1251/446/PR/150724/006941",
        status: "New Launch"
      }
    },
    overview: {
      heading: "TVS Isle of Trees - Premium Living in North Bangalore",
      description: [
        "Situated in the tranquil neighborhood of Rachenahalli, near Hebbal in North Bangalore, TVS Isle of Trees is a premium residential project by TVS Emerald. This development offers a harmonious blend of luxury and nature, providing residents with a peaceful living environment.",
        "The project spans 2.71 acres and comprises 154 meticulously designed 3 and 4 BHK apartments. Each unit is a corner home with no shared walls, ensuring privacy and excellent ventilation. The apartments range from 1,500 to 2,375 sq. ft., catering to diverse family needs.",
        "TVS Isle of Trees is strategically located just behind Manyata Tech Park, offering unparalleled convenience for professionals. The area boasts excellent connectivity to key parts of the city, including Thanisandra Road and Outer Ring Road. Essential amenities such as schools, hospitals, and shopping centers are in close proximity, enhancing the quality of life for residents.",
      ],
      keywordLinks: {
       
      },
      image: overviewImageisleoftrees,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconisleoftrees,
          title: "₹ 1.83 Crore Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconisleoftrees,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconisleoftrees,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    
    floor_plan: [
      {
        type: "3 BHK",
        area: "1500 - 1801 sq. ft.",
        price: "₹ 1.83 - 2.2 Crore Onwards",
        image: floorplan1isleoftrees,
      },
      {
        type: "4 BHK",
        area: "2323 - 2375 sq. ft.",
        price: "₹ 2.83 - 2.89 Crore Onwards",
        image: floorplan2isleoftrees,
      }
    ],
    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1500 - 1801 sq. ft.",
          price: "₹ 1.83 - 2.2 Crore Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2323 - 2375 sq. ft.",
          price: "₹ 2.83 - 2.89 Crore Onwards",
          eoiAmount: "On Request",
        }
      ],
    },
     highlights: {
      images: Hightlightsisleoftrees,
      tagline: "Highlights",
      features: [
        "Development spans across 2.71 acres",
        "3 towers with 14 stories each",
        "154 premium residences",
        "IGBC Gold pre-certified",
        "Over 40 world-class amenities",
        "Corner units with no shared walls"
      ],
    },

    location: {
      image: Locationisleoftrees, 
      data: [
        {
          airport: {
            distance_time: "25.5 km",
            name: "Kempegowda International Airport"
          },
          school: {
            distance_time: "1.7 Km",
            name: "Morning Star Public School"
          },
          railwayormetro: {
            distance_time: "2.5 Km",
            name: "SH 104"
          },
          hospital: {
            distance_time: "2.5 Km",
            name: "Chirayu Hospital"
          },
          mall: {
            distance_time: "6.3 Km",
            name: "Bhartiya Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1isleoftrees },
        { image: gallery2isleoftrees },
        { image: gallery3isleoftrees },
        { image: gallery4isleoftrees },
        { image: gallery5isleoftrees },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in TVS Isle of Trees, kindly share more details.",
    },

    faq: [
      {
        question: "Where is TVS Isle of Trees located in Bangalore?",
        answer: `TVS Isle of Trees is strategically located in Yelahanka, North Bangalore.`,
      },
      {
        question: "What types of apartments are available at TVS Isle of Trees Hebbal, Bangalore?",
        answer: `The project offers spacious 3 BHK and 4 BHK apartments designed with modern layouts.`,
      },
      {
        question: "Who is the developer of TVS Isle of Trees?",
        answer: `TVS Isle of Trees is developed by TVS Emerald.`,
      },
      {
        question: "What is the average size of apartments in this residential project?",
        answer: `The average size of apartments in this residential project ranges from 1500 sq.ft. -2375 sq.ft.`,
      },
      {
        question: "What are the key amenities offered at TVS Isle of Trees?",
        answer: `The project boasts world-class amenities including a clubhouse, swimming pool, jogging track, kids' play area.`,
      },
      {
        question: "Is TVS Isle of Trees a RERA-approved project?",
        answer: `Yes, TVS Isle of Trees is RERA-registered project with registration number PRM/KA/RERA/1251/446/PR/150724/006941.`,
      },
      {
        question: "How well is TVS Isle of Trees Hebbal, Bangalore connected to the rest of Bangalore?",
        answer: `TVS Isle of Trees offers excellent connectivity to key areas like Hebbal, Airport Road, Manyata Tech Park.`,
      },
      {
        question: "Are there educational institutions and hospitals nearby?",
        answer: `Yes, reputed schools, colleges, and hospitals like Ryan International School, Canadian International School, Columbia Asia Hospital, and Aster CMI are within easy reach of the project.`,
      },
      {
        question: "Is TVS Isle of Trees suitable for investment purposes?",
        answer: `Absolutely. Its strategic location in North Bangalore, proximity to upcoming infrastructure developments, and the reputation of the developer make it an excellent investment option.`,
      },
      {
        question: "How can I book an apartment at TVS Isle of Trees?",
        answer: `Interested buyers can contact our sales team for detailed pricing, floor plans, and booking procedures.`,
      },
    ],

    similar:{
      properties: [
        {
          name: "TVS Emerald Cascadia - CBD",
          image: y,
          price: "₹ 6.49 Crore Onwards",
          developer:"TVS",
          state:"Bangalore",
          location: "Sudhama Nagar, Mission Road, Bangalore",
          projectlocation:"Central Bangalore",
          bed: "3 & 4 BHK",
          size: "1473 - 2318 sq.ft.",
          url: `/tvs-emerald-cascadia-mission-road-bangalore`,
          form:{
            source_id:11,
            api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id:130,
            builder_id:`103`,
            project_id:`477`,
            subject: "TVS Emerald Cascadia", 
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `478`,
      subject: "Property Station enquiry - TVS Isle of Trees", 
      to_email: "leads@gurugram-property.com",
    },
  },

};
